import { usePageTitle } from "~/shared";
import { FAQDesktop, FAQMobile } from "./components";

export const FAQ = () => {
  usePageTitle("FAQs");

  return (
    <>
      <FAQMobile />
      <FAQDesktop />
    </>
  );
};
